import { Injectable, Type } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VendorService {
  constructor(private http: HttpClient) { }
  // private baseUrl = 'https://globalsources-erp-staging-24532743.dev.odoo.com/odoo';
  // private baseUrl = 'https://globalsources-erp.odoo.com/odoo';
   private baseUrl = environment.apiUrl;

  signupVendor(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + '/vendor/signup', payload);
  }

  vendorEvaluation(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + '/vendor/evaluation', payload);
  }

  getPurchaseOrders(): Observable<any> {
    // let token = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoxMzIsImxvZ2luIjoibmlkYWx2ZW5kb3JAZ21haWwuY29tIiwiZXhwIjoxNzU3MTcxOTcwLCJpYXQiOjE3NTcxNDMxNzB9.b9oxWyq8FWjj3uYAjvvHEuaF1iyQ_HMShyWALyJFvEs";
    let token = sessionStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`
    };

    const body = {
      jsonrpc: '2.0',
      method: 'call',
      params: {}
    };

    return this.http.post<any>(
      this.baseUrl + '/get/purchase/orders',
      body,
      { headers }
    );
  }

  getOrderDetailsByID(Id: number): Observable<any> {
    let token = sessionStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`
    };

    const body = {
      jsonrpc: '2.0',
      method: 'call',
      params: { 'PurchaseID': Id }
    };

    return this.http.post<any>(
      this.baseUrl + '/get/bills',
      body,
      { headers }
    );
  }

  uploadFiles(payload: any): Observable<any> {
    let token = sessionStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`
    };

    return this.http.post<any>(
      this.baseUrl + '/upload/purchase/attachments',
      payload,
      { headers }
    );
  }

  getUploadFiles(Id: number,Type:string): Observable<any> {    
    let token = sessionStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`
    };
    const body = {
      jsonrpc: '2.0',
      method: 'call',
      params: { 'PurchaseID': Id,'TYPE':Type }
    };
    return this.http.post<any>(
      this.baseUrl + '/get/purchase/attachments',
      body,
      { headers }
    );
  }

    getOutstandingReport(): Observable<any> {
    let token = sessionStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`
    };

    const body = {
      jsonrpc: '2.0',
      method: 'call',
      params: {}
    };

    return this.http.post<any>(
      this.baseUrl + '/get/outstanding/invoices_bills',
      body,
      { headers }
    );
  }    

  changePassword(payload: any): Observable<any> {    
    let token = sessionStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${token}`
    };
     return this.http.post(this.baseUrl + '/vendor/change_password',payload, { headers });
  }
}
